<form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
<h4 class="development-title pl-[104px] bg-[#F8F8F8] h-[100px] items-center justify-center pt-[25px]">Expression of
    Interest</h4>
<div class="container-fluid flex justify-center  h-auto p-[29px] !m-[3px] !mt-[5px] !mb-[10px] !pb-[0px]">
    <mat-card class="!p-[30px] !pb-0 !rounded-[15px] shadow-lg !bg-[#ffffff] w-full !pt-[0px]">
        <h3 class="text-[20px] font-semibold !pl-[60px] !mb-[0px]">Applicant Details</h3>
        <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container">

            <!-- <h3 class="!pl-[60px] col-span-12">Applicant Details</h3> -->

            <div class="container p-5 !pt-0 !pb-0">
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
                        <mat-label>
                            Company Name
                        </mat-label>
                        <input matInput formControlName="company_name" placeholder="Company Name">
                    </mat-form-field>
                    <div *ngIf="formGroup.get('company_name').invalid && formGroup.get('company_name').touched" class="error-message">
                        <span style="color: red;">Company Name is required</span>
                      </div>
                </div>
            </div>
            <div class="container p-5 !pt-0 !pb-0">
                <div class="rounded p-10 !pb-0 !pt-0 !mb-[40px]">
                    <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
                        <mat-label>Contact Pereson</mat-label>
                        <input matInput formControlName="contact_person" placeholder="Contact Pereson">
                    </mat-form-field>
                    <div *ngIf="formGroup.get('contact_person').invalid && formGroup.get('contact_person').touched" class="error-message">
                        <span style="color: red;">Contact Pereson is required</span>
                      </div>
                </div>
            </div>


            <div class="container p-5 !pb-0 !pt-0">
                <div class="rounded p-10 !pb-0 !pt-0 !mb-[40px]">
                    <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
                        <mat-label>Company Registration Number</mat-label>
                        <input matInput formControlName="company_reg_no" placeholder="Company Registration Number">
                    </mat-form-field>
                    <div *ngIf="formGroup.get('company_reg_no').invalid && formGroup.get('company_reg_no').touched" class="error-message">
                        <span style="color: red;">Company Registration Number is required</span>
                      </div>
                </div>
            </div>
            <div class="container p-5 !pb-0 !pt-0">
                <div class="rounded p-10 !pb-0 !pt-0 !mb-[40px]">
                    <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
                        <mat-label>Position</mat-label>
                        <input matInput formControlName="contact_person_position" placeholder="Position">
                    </mat-form-field>
                    <div *ngIf="formGroup.get('contact_person_position').invalid && formGroup.get('contact_person_position').touched" class="error-message">
                        <span style="color: red;">Position is required</span>
                      </div>
                </div>
            </div>



            <div class="container p-5 !pb-0 !pt-0">
                <div class="rounded p-10 !pb-0 !pt-0 !mb-[40px]">
                    <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
                        <mat-label>VAT Registration Number</mat-label>
                        <input matInput formControlName="company_vat_no" placeholder="VAT Registration Number">
                    </mat-form-field>
                    <div *ngIf="formGroup.get('company_vat_no').invalid && formGroup.get('company_vat_no').touched" class="error-message">
                        <span style="color: red;">VAT Registration Number is required</span>
                      </div>
                </div>
            </div>
            <div class="container p-5 !pb-0 !pt-0">
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px]" appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" type="email" placeholder="Email">
                    </mat-form-field>
                </div>
            </div>


            <div class="container p-5 !pb-0 !pt-0">
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px]" appearance="outline">
                        <mat-label>Website</mat-label>
                        <input formControlName="website" matInput placeholder="Website">
                    </mat-form-field>
                </div>
            </div>
            <div class="container p-5 !pb-0 !pt-0">
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[250px]" appearance="outline">
                        <mat-label>Telephone</mat-label>
                        <input formControlName="phone" matInput type="number" placeholder="Telephone">
                    </mat-form-field>
                </div>
            </div>


            <div class="container p-5 !pb-0 !pt-0 !h-[150px]">
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px] !h-[150px] !mb-[0px]" appearance="outline">
                        <mat-label>Address</mat-label>
                        <input formControlName="address" matInput placeholder="Address">
                    </mat-form-field>
                </div>
            </div>
            <div class="container p-5 !pb-0 !pt-0 !h-[150px]">
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px] !mb-[20px]" appearance="outline">
                        <mat-label>City</mat-label>
                        <input formControlName="city" matInput placeholder="City">
                    </mat-form-field>
                </div>
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[250px] !mb-[0px]" appearance="outline">
                        <mat-label>State/Province</mat-label>
                        <input formControlName="state" matInput placeholder="State/Province">
                    </mat-form-field>
                </div>
            </div>

            <div class="container p-5 !pb-0 !pt-0">
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px]" appearance="outline">
                        <mat-label>Country</mat-label>
                        <input formControlName="country" matInput placeholder="Country">
                    </mat-form-field>
                </div>
            </div>
            <div class="container p-5 !pb-0 !pt-0">
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[250px]" appearance="outline">
                        <mat-label>Zip/Postal Code</mat-label>
                        <input formControlName="zip" matInput type="number" placeholder="Zip/Postal Code">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </mat-card>
</div>

<div class="container-fluid flex justify-center  h-auto p-[29px] !pt-[0px] !m-[3px] !mt-[0px] !mb-[10px] !pb-[0px]">
    <mat-card class="!p-[30px] !pb-0 !rounded-[15px] shadow-lg !bg-[#ffffff] w-full">
        <h3 class="text-[20px] font-semibold !pl-[60px] !mb-[0px]">Scope of Interest</h3>
        <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container">

            <!-- <h3 class="!pl-[60px] col-span-12">Applicant Details</h3> -->

            <div class="container p-5 !pt-0 !pb-0">
                <div class="rounded p-10 !pb-0 !pt-0 !mb-[40px]">
                    <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
                        <mat-label>Nature of Service</mat-label>
                        <input formControlName="nature_of_service" matInput placeholder="Nature of Service">
                    </mat-form-field>
                    <div *ngIf="formGroup.get('nature_of_service').invalid && formGroup.get('nature_of_service').touched" class="error-message">
                        <span style="color: red;">Nature Of Service is required</span>
                      </div>
                </div>
            </div>
            <div class="container p-5 !pt-0 !pb-0">
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px]" appearance="outline">
                        <mat-label>Expected Start Date</mat-label>
                        <input formControlName="expected_start_date" matInput type="date" placeholder="Expected Start Date">
                    </mat-form-field>
                </div>
            </div>


            <div class="container p-5 !pb-0 !pt-0">
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px]" appearance="outline">
                        <mat-label>Type of Project</mat-label>
                        <input formControlName="type_of_project" matInput placeholder="Type of Project">
                    </mat-form-field>
                </div>
            </div>
            <div class="container p-5 !pb-0 !pt-0">
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px]" appearance="outline">
                        <mat-label>Expected End Date</mat-label>
                        <input formControlName="expected_end_date" matInput type="date" placeholder="Expected End Date">
                    </mat-form-field>
                </div>
            </div>



            <div class="container p-5 !pb-0 !pt-0">
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px]" appearance="outline">
                        <mat-label>Project Location</mat-label>
                        <input formControlName="project_location" matInput placeholder="Project Location">
                    </mat-form-field>
                </div>
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px]" appearance="outline">
                        <mat-label>Estimation Project Value</mat-label>
                        <input formControlName="estimation_price" matInput type="number" placeholder="Estimation Project Value">
                    </mat-form-field>
                </div>
            </div>

        </div>
    </mat-card>

</div>

<div class="container-fluid flex justify-center  h-auto p-[29px] !pt-[0px] !m-[3px] !mt-[0px] !mb-[10px] !pb-[0px]">
    <mat-card class="!p-[30px] !pb-0 !rounded-[15px] shadow-lg !bg-[#ffffff] w-full">
        <h3 class="text-[20px] font-semibold !pl-[60px] !mb-[0px]"> Experience & Capability (If Applicable)</h3>
        <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container">

            <!-- <h3 class="!pl-[60px] col-span-12">Applicant Details</h3> -->

            <div class="container p-5 !pt-0 !pb-0">
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px]" appearance="outline">
                        <mat-label>Relevant Experience</mat-label>
                        <input formControlName="experience" matInput type="number" placeholder="Relevant Experience">
                    </mat-form-field>
                </div>
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px]" appearance="outline">
                        <mat-label>Key Qualifications</mat-label>
                        <input formControlName="qualifications" matInput placeholder="Key Qualifications">
                    </mat-form-field>
                </div>
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px]" appearance="outline">
                        <mat-label>Team Composition</mat-label>
                        <input formControlName="team_composition" matInput placeholder="Team Composition">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </mat-card>
</div>

<div class="container-fluid flex justify-center  h-auto p-[29px] !pt-[0px] !m-[3px] !mt-[0px] !mb-[10px] !pb-[0px]">
    <mat-card class="!p-[30px] !pb-0 !rounded-[15px] shadow-lg !bg-[#ffffff] w-full">
        <h3 class="text-[20px] font-semibold !pl-[60px] !mb-[0px]"> Compliance & Policies</h3>
        <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container">

            <!-- <h3 class="!pl-[60px] col-span-12">Applicant Details</h3> -->

            <div class="container p-5 !pt-0 !pb-0">
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px]" appearance="outline">
                        <mat-label>Health, Safety & Environmental Policy</mat-label>
                        <input formControlName="health_safety_environmental_policy" matInput placeholder="Health, Safety & Environmental Policy">
                    </mat-form-field>
                </div>
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px]" appearance="outline">
                        <mat-label>Quality Assurance Certification</mat-label>
                        <input formControlName="quality_assurance_cert_attach" matInput placeholder="Quality Assurance Certification">
                    </mat-form-field>
                </div>
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[500px]" appearance="outline">
                        <mat-label>Conflict of Interest Disclosure</mat-label>
                        <input formControlName="conflict_of_interest" matInput placeholder="Conflict of Interest Disclosure">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </mat-card>
</div>

<div class="container-fluid flex justify-center  h-auto p-[29px] !pt-[0px] !m-[3px] !mt-[0px] !mb-[10px] !pb-[0px]">
    <mat-card class="!p-[30px] !pb-0 !rounded-[15px] shadow-lg !bg-[#ffffff] w-full">
        <h3 class="text-[20px] font-semibold !pl-[60px] !mb-[0px]"> Additional Information</h3>
        <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 container">

            <!-- <h3 class="!pl-[60px] col-span-12">Applicant Details</h3> -->

            <div class="container p-5 !pt-0 !pb-0">
                <div class="rounded p-10 !pb-0 !pt-0">
                    <mat-form-field class="!w-[100%] !h-[115px]" appearance="outline">
                        <mat-label>Additional Information</mat-label>
                        <input formControlName="description" matInput placeholder="Additional Information">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </mat-card>
</div>

<div class="container-fluid flex justify-center  h-auto p-[29px] !pt-[0px] !m-[3px] !mt-[0px] !mb-[10px] !pb-[0px]">
    <mat-card class="!p-[30px] !pb-0 !rounded-[15px] shadow-lg !bg-[#ffffff] w-full">
        <h3 class="text-[20px] font-semibold !pl-[60px] !mb-[0px]">Declaration</h3>
        <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container">

            <!-- <h3 class="!pl-[60px] col-span-12">Applicant Details</h3> -->

            <div class="container p-5 !pt-0 !pb-0">
                <div class="rounded p-10 !pb-0 !pt-0 !mb-[40px]">
                    <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
                        <mat-label>Name of Authorized Representative</mat-label>
                        <input formControlName="authorized_representative" matInput placeholder="Name of Authorized Representative">
                    </mat-form-field>
                    <div *ngIf="formGroup.get('authorized_representative').invalid && formGroup.get('authorized_representative').touched" class="error-message">
                        <span style="color: red;">Authorized Representative Name is required</span>
                      </div>
                </div>
            </div>
            <div class="container p-5 !pt-0 !pb-0">
                <div class="rounded p-10 !pb-0 !pt-0 !mb-[40px]">
                    <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
                        <mat-label>Position</mat-label>
                        <input formControlName="authorized_representative_position" matInput placeholder="Position">
                    </mat-form-field>
                    <div *ngIf="formGroup.get('authorized_representative_position').invalid && formGroup.get('authorized_representative_position').touched" class="error-message">
                        <span style="color: red;">Representative Position is required</span>
                      </div>
                </div>
            </div>


            <div class="container p-5 !pb-0 !pt-0">
                <div class="rounded p-10 !pb-0 !pt-0 !mb-[40px]">
                    <mat-form-field class="!w-[500px] !mb-[10px]" appearance="outline">
                        <mat-label>Signature</mat-label>
                        <input formControlName="signature" matInput placeholder="Signature">
                    </mat-form-field>
                    <div *ngIf="formGroup.get('signature').invalid && formGroup.get('signature').touched" class="error-message">
                        <span style="color: red;">Signature is required</span>
                      </div>
                </div>
            </div>

            <div class="container p-5 !pb-0 !pt-0">
                <div class="rounded p-10 !pb-0 !pt-0 !mb-[40px]">
                    <mat-form-field class="!w-[500px] !mb-[10px]" type="date" appearance="outline">
                        <mat-label>Date</mat-label>
                        <input formControlName="date" matInput placeholder="Date" type="date">
                    </mat-form-field>
                    <div *ngIf="formGroup.get('date').invalid && formGroup.get('date').touched" class="error-message">
                        <span style="color: red;">Date is required</span>
                      </div>
                </div>
            </div>
        </div>
    </mat-card>
</div>

<div class="container-fluid p-[29px] !pr-[35px] !mt-[5px] bg-[#ffffff]">
    <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div class="rounded flex justify-end">
            <button type="button" class="back-button !mr-[10px]">Back</button>
            <button type="submit" class="save-button">Save</button>
        </div>
    </div>

</div>
</form>
